export const REVIEW_NOW_LABEL = 'Review Now';
